<template>
  <div id="admin-content" class="d-flex flex-row">
    <AdminSidebar id="admin-sidebar" class="sticky-top" />
    <transition name="fade" mode="out-in">
      <router-view class="flex-fill" />
    </transition>
  </div>
</template>

<script>
import AdminSidebar from '../../components/admin/AdminSidebar';
export default {
  name: 'AdminPage',
  components: { AdminSidebar },
  props: {},
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style scoped>
#admin-sidebar {
  width: 120px;
}
#admin-content {
  overflow: hidden;
  background: white;
  height: 100vh;
}
</style>
